module.exports = __webpack_public_path__ + "img/job.9092c71d.svg";